import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/pages/HomePage';
import MenuPage from './components/pages/MenuPage';
import Reservations from './components/pages/Reservations';
import SignUp from './components/pages/SignUp';
import Footer from './components/Footer';
import EquipePage from './components/pages/EquipePage';
import MentionsPage from './components/pages/MentionsPage'
import TraiteurPage from './components/pages/TraiteurPage';
import VinsPage from './components/pages/VinsPage';
import TerrassePage from './components/pages/TerrassePage';
import BonCadeauPage from './components/pages/BonCadeauPage';

function App() {
  return (
    <>
      <Router>
        <Navbar />
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/menu' element={<MenuPage />} />
            <Route path='/reservations' element={<Reservations />} />
            <Route path='/sign-up' element={<SignUp />} />
            <Route path='/equipe' element={<EquipePage />} />
            <Route path='/mentions' element={<MentionsPage />} />
            <Route path='/traiteur' element={<TraiteurPage />} />
            <Route path='/vins' element={<VinsPage />} />
            <Route path='/terrasse' element={<TerrassePage />} />
            <Route path='/bon-cadeau' element={<BonCadeauPage />} />
          </Routes>
          <Footer />
      </Router>
    </>
  );
}

export default App;
